import {Swiper, Navigation, Autoplay, Lazy} from 'swiper';
Swiper.use([ Navigation, Autoplay, Lazy]);

const relatedSwiper = new Swiper('.swiper-related', {
    spaceBetween: 50,
    autoHeight: true,
    breakpoints: {
        800: {
            slidesPerView: 2
        },
        1050: {
            slidesPerView: 3
        },
        1400: {
            slidesPerView: 4
        }
    },

    navigation: {
        nextEl: '.related-swiper-button-next',
        prevEl: '.related-swiper-button-prev',
    },
});